import { DisabledPrompt, ModalClose } from "@bcm-dev/bcms-vite";
import React from "react";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton, ModalSecondaryButton } from "../..";
import "./styles.css";
/**
 * @function RedirectModal
 * @return {React.Component}
 * @exported true
 * @description The main component for RedirectModal
 */
export default function RedirectModal(props) {
    
    return (
        <CustomModal className="redirect-modal" id="RedirectModal">
            <CustomModalContent>
                <p className="text-center">You will be redirected to a secure page to select your payment accounts. You will be required to authenticate with the financial institution associated with these accounts. Once the selections are completed, please return to this page.</p>
            </CustomModalContent>
            <CustomModalFooter className="button-container">
                <DisabledPrompt>
                  <ModalPrimaryButton text="OK" id="RedirectModal" onClick="" />
                </DisabledPrompt>
                
                <ModalClose id="RedirectModal">
                    <ModalSecondaryButton text="Cancel" />
                </ModalClose>
            </CustomModalFooter>
        </CustomModal>
    )
}
